import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function Badge({ children, className, withBorder = true, top = 'top-2', right = 'right-4', }) {
    return (_jsx("span", { className: clsx('absolute flex items-center justify-center whitespace-nowrap rounded-full bg-warning text-xs font-bold text-white shadow', withBorder && 'border-2 border-white', children ? 'h-18 w-18' : 'h-12 w-12', className, top, right), children: children }));
}
